module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_7.9a592554.png";